import { Route } from "@angular/router";

export const DashboardPaths = {};

export let dashboardParent = "";

export default [
  {
    path: "",
    loadComponent: () =>
      import("./pages/dashboard/dashboard.component").then((c) => c.DashboardComponent),
    data: {
      breadcrumb: "Startpagina",
      title: " ",
    },
  },
] satisfies Route[];
